import {
  isFeatureFlagEnabled,
  type FeatureFlag,
  type FeatureFlagState,
  type UseFeatureFlagUtilsResult,
} from '@onesource/components';
import { z } from 'zod';

export const EFeatureFlagKey = z.enum([
  'SHOW_ADDON_APP',
  'SHOW_COLLAPSIBLE_SIDEBAR',
  'SHOW_COMMUNITY_WIDGETS',
  'SHOW_LOCKED_SPACES',
  'SHOW_PRO_DIRECTORY',
]);
export const EFeatureFlagEnum = EFeatureFlagKey.enum;
export type TFeatureFlagKey = z.infer<typeof EFeatureFlagKey>;

export const FEATURE_FLAGS_FOR_UI: FeatureFlag[] = [
  {
    key: EFeatureFlagEnum.SHOW_ADDON_APP,
    label: 'Show Mini Programs',
    defaultValue: false,
    description: 'Show the Addon app and mini programs in the apps list',
    disabled: import.meta.env.VITE_PROGRAMS_FE_URL === undefined,
    disabledReason: 'VITE_PROGRAMS_FE_URL is not configured',
  },
  {
    key: EFeatureFlagEnum.SHOW_COLLAPSIBLE_SIDEBAR,
    label: 'Collapsible Sidebar',
    defaultValue: false,
    description:
      'New sidebar submenu experience: collapse/expand toggle and grouped folder items (spaces/feeds nested under their parent container). When off, the panel is always expanded and items render as a flat list.',
  },
  {
    key: EFeatureFlagEnum.SHOW_COMMUNITY_WIDGETS,
    label: 'Show Community Widgets',
    defaultValue: false,
    description:
      'Show the Trending Tags, Community Stats and Top Contributors cards in the community feed sidebar (and their tabs in the mobile details sheet).',
  },
  {
    key: EFeatureFlagEnum.SHOW_LOCKED_SPACES,
    label: 'Show Locked Spaces',
    defaultValue: false,
    description: 'Show locked/inaccessible spaces on the apps page and navigation',
  },
  {
    key: EFeatureFlagEnum.SHOW_PRO_DIRECTORY,
    label: 'Show Pro Directory',
    defaultValue: false,
    description: 'Show the Pro Directory tab on the My Account page',
  },
] as const;

export { isFeatureFlagEnabled };
export type { FeatureFlag, FeatureFlagState, UseFeatureFlagUtilsResult };
